export default {"src":"/_next/static/image/public/images/flags/flag_255.8838bb0c3df7b91fd5f896c685ba07d4.svg","height":16,"width":24};